<template>
  <v-app>
    <v-main>
      <!-- This will render the component based on the current route -->
      <!-- <router-view /> -->
      <WelcomePage v-if="$store.state.step == 1" />
      <ChangeDetails v-if="$store.state.step == 2" />
    </v-main>
  </v-app>
</template>

<script>
import WelcomePage from "./components/WelcomePage.vue";
import ChangeDetails from "./components/ChangeDetails.vue";

export default {
  components: { WelcomePage, ChangeDetails },
  name: "App",
  data: () => ({}),
  mounted() {
    this.$store.state.step = 1;
  },
  computed: {
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1 ||
        location.href.toLowerCase().indexOf("me360dev") > -1
        ? "/web_projects"
        : "http://localhost/web_projects";
    },
  },
  methods: {
    intialloadfn() {},
  },
};
</script>

<style scoped>
/* Your global styles */
</style>
